import { FC, ChangeEvent } from 'react';
import { useDispatch } from 'react-redux';

import Analytics from '@hh.ru/analytics-js';
import { useSelector } from '@hh.ru/front-static-app';
import {
    EmojiNeutral3dSize32,
    EmojiSad3dSize32,
    EmojiHalfsad3dSize32,
    EmojiHalfsmile3dSize32,
    EmojiSmile3dSize32,
} from '@hh.ru/magritte-ui/icon';

import { Rating } from 'src/components/VacancyAdvicesModal/constants';
import { setRatingVacancyAdvicesModal } from 'src/models/vacancyAdvicesModal';

import styles from './rating-chooser.less';

const RATING_TO_ICON = {
    [Rating.Sad]: EmojiSad3dSize32,
    [Rating.Halfsad]: EmojiHalfsad3dSize32,
    [Rating.Neutral]: EmojiNeutral3dSize32,
    [Rating.Halfsmile]: EmojiHalfsmile3dSize32,
    [Rating.Smile]: EmojiSmile3dSize32,
};

const RatingChooser: FC = () => {
    const dispatch = useDispatch();

    const {
        rating: selectedRating,
        vacancy: { vacancyId },
    } = useSelector((state) => state.vacancyAdvicesModal);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const rating = event.target.value as Rating;
        Analytics.sendHHEventButtonClick('employer_vacancies_advice_feedback_rating_item', {
            vacancyId,
            rating,
        });
        dispatch(setRatingVacancyAdvicesModal(rating));
    };

    return (
        <div className={styles.ratingChooser}>
            {Object.entries(RATING_TO_ICON).map(([rating, IconComponent]) => (
                <label key={rating} className={styles.ratingChooserItem}>
                    <input
                        type="radio"
                        name="vacancy-advice-feedback-modal-rating"
                        value={rating}
                        className={styles.ratingChooserRadio}
                        onChange={onChange}
                        checked={selectedRating === rating}
                    />
                    <IconComponent />
                </label>
            ))}
        </div>
    );
};

export default RatingChooser;
